<template>
  <div id="zcglIndex">
    <div v-show="!$route.meta.showjjgk">
      <div class="tab">
        <a v-for="(item,index) in jjfl" @click="tabindex=index" :class="{ active: tabindex===index}">{{item.name}}</a>
      </div>
      <div class="cplist">
        <div v-for="(item,index) in jjfl" v-if="tabindex===index">
          <div v-for="jj in item.list" class="jjlist" @click="jjgk(jj.id)">
            <div class="title">
              <div class="i">i</div>
              {{jj.name}}
            </div>
            <div class="ljnh" :class="{ green: parseFloat(jj.ljnh)<0}">
              <p>{{parseFloat(jj.ljnh).toFixed(2)}}%</p>
              <p class="xz">累计年化收益</p>
            </div>
            <div class="xx">
              <p class="bule">单位净值：{{jj.dwjz}}</p>
              <p>成立日期：<span>{{jj.clrq}}</span></p>
              <p>更新日期：<span>{{jj.gxrq}}</span></p>
            </div>
            <hr/>
          </div>
        </div>
      </div>
      <div class="gglist">
        <div class="listTitle">资产管理公告</div>
        <List :list="gglist" name="zcgl" :ShowTime="true" :count="5"></List>
        <div class="ShowMore" style="display: inherit">
          <router-link :to="{ name: 'zcgl', params: { nr: 'gglist' }}">点击查看更多</router-link>
        </div>
      </div>
    </div>
    <router-view v-show="$route.meta.showjjgk" class="min-height"></router-view>
  </div>
</template>

<script>
  import List from '@/components/list/List'
  import ajax from '@/common/ajax/ajax'
  import router from '@/router'

  export default {
    name: 'zcglIndex',
    data () {
      return {
        gglist: [],
        jjfl: [],
        tabindex: 0
      }
    },
    created: function () {
      if (!this.$route.meta.showjjgk) {
        this.$emit('update:titlestr', '资产管理')
      } else {
        this.$emit('update:titlestr', '基金概况')
      }
      ajax.islogin().then(
        () => {
        },
        () => {
          router.replace({name: 'zcgl', params: {nr: 'login'}})
        }
      )
      ajax.getCfgllist().then(
        data => {
          this.gglist = data
        }
      )
      ajax.getCfglJjfl().then(
        data => {
          this.jjfl = data
          this.jjfl.forEach(item => {
            ajax.getJjList(item).then(jjlist => {
              let alllist = []
              jjlist.forEach(list => {
                alllist = alllist.concat(list)
              })
              item.list = alllist
            })
          })
        }
      )
    },
    components: {
      List
    },
    watch: {
      $route: function () {
        if (!this.$route.meta.showjjgk) {
          this.$emit('update:titlestr', '资产管理')
        } else {
          this.$emit('update:titlestr', '基金概况')
        }
      }
    },
    methods: {
      jjgk: function (id) {
        router.push({name: 'jjgk', params: {id: id}})
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus">
  @import "../../../common/stylus/common.styl"
  #zcglIndex
    .tab
      padding 0 $bj 0 $bj
      background-color $color2
      font-size $font_size2
      color $font_color3
      height 40px
      line-height 40px
      text-align center
      a
        padding 0 15px 0 15px
        border-right solid 1px #a3b8ea
        &.active
          color $font_color2
        &:last-child
          border-right 0
    .cplist
      background-color #fff
      padding 0 $bj 0 $bj
      .jjlist
        position relative
        .title
          margin-left -15px
          padding-top 15px
          padding-bottom 16px
          color $font_color1
          font-size $font_size3
          line-height $font_size3
          .i
            width 6px
            height 15px
            color transparent
            background-color $color1
            margin-right 9px
            display inline-block
        .ljnh
          color #992525
          font-size 23px
          float left
          border-right 1px solid #d9d9d9
          padding-right 18px
          width: 30%;
          text-align right
          p
            margin 0
          .xz
            font-size 10px
            color #c4c4c4
          &.green
            color #339841
        .xx
          float left
          width 70%
          font-size 10px
          padding-left 18px
          span
            margin-left 0
            color #c4c4c4
          .bule
            color #5570ba
          p
            margin 0

        hr
          width 100%
          margin-top 70px
          margin-bottom 0
        &:after
          content '\f105'
          position absolute
          right 0
          font-size 40px
          top 40px
          color #8e8e8e
          transform: scale(1, 1.1)

    .gglist
      .List
        ul
          li
            margin 0
            .title
              margin-left 0
    .ShowMore
      display none

  .gglist
    padding 0 $bj 0 $bj
    .listTitle
      color #a88b6b
      font-size 16px
      padding-top 25px
      margin-bottom 14px
      line-height 16px
      text-align center


</style>



// WEBPACK FOOTER //
// index.vue?f2d2f852